import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaFemale } from 'react-icons/fa';
import PJALogo from '../../assets/img/patient-journey-logo.svg';

const SideMenu: React.FC = () => {
  return (
    <nav className="fixed inset-y-0 left-0 flex flex-col w-[250px] h-screen bg-nav-bg border-r border-nav-border z-40">
      {/* Header / Brand */}
      <a
        href="/"
        className="flex items-center gap-3 min-h-[56px] px-3 bg-nav-bg border-b border-nav-border"
      >
        <img
          src={PJALogo}
          alt="Patient Journey Analytics logo"
          className="w-10 h-10 pl-1.5 shrink-0"
        />
        <h1 className="text-xl font-semibold tracking-wide text-nav-text">
          Momcare
        </h1>
      </a>

      {/* Navigation items */}
      <ul className="flex flex-col flex-1 gap-1 mt-2 px-2">
        <li>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              [
                'flex items-center gap-3 px-5 py-3 rounded-full text-nav-text text-lg',
                'transition-colors duration-150',
                isActive
                  ? 'bg-nav-active font-bold'
                  : 'hover:bg-nav-hover',
              ].join(' ')
            }
          >
            <FaFemale size={20} />
            Enroll Mom
          </NavLink>
        </li>
        {/* Enroll Baby — uncomment when form is ready
        <li>
          <NavLink
            to="/enroll_baby"
            className={({ isActive }) =>
              [
                'flex items-center gap-3 px-5 py-3 rounded-full text-nav-text text-lg',
                'transition-colors duration-150',
                isActive ? 'bg-nav-active font-bold' : 'hover:bg-nav-hover',
              ].join(' ')
            }
          >
            <FaBaby size={20} />
            Enroll Baby
          </NavLink>
        </li>
        */}
      </ul>
    </nav>
  );
};

export default SideMenu;
